/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as WWorkspaceIdRouteImport } from "./routes/w.$workspaceId"
import { Route as WWorkspaceIdIndexRouteImport } from "./routes/w.$workspaceId/index"
import { Route as WWorkspaceIdAuditRouteImport } from "./routes/w.$workspaceId/audit"
import { Route as WWorkspaceIdSecurityRouteImport } from "./routes/w.$workspaceId/security"
import { Route as WWorkspaceIdSurveysIndexRouteImport } from "./routes/w.$workspaceId/surveys.index"
import { Route as WWorkspaceIdSurveysSurveyIdRouteImport } from "./routes/w.$workspaceId/surveys.$surveyId"
import { Route as WWorkspaceIdSurveysNewRouteImport } from "./routes/w.$workspaceId/surveys.new"
import { Route as WWorkspaceIdTemplatesIndexRouteImport } from "./routes/w.$workspaceId/templates.index"
import { Route as WWorkspaceIdTemplatesTemplateIdRouteImport } from "./routes/w.$workspaceId/templates.$templateId"
import { Route as WWorkspaceIdTemplatesNewRouteImport } from "./routes/w.$workspaceId/templates.new"
import { Route as WWorkspaceIdSurveysSurveyIdIndexRouteImport } from "./routes/w.$workspaceId/surveys.$surveyId.index"
import { Route as WWorkspaceIdSurveysSurveyIdResponsesRouteImport } from "./routes/w.$workspaceId/surveys.$surveyId.responses"
import { Route as WWorkspaceIdSurveysSurveyIdResultsRouteImport } from "./routes/w.$workspaceId/surveys.$surveyId.results"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdRoute = WWorkspaceIdRouteImport.update({
  id: "/w/$workspaceId",
  path: "/w/$workspaceId",
  getParentRoute: () => rootRouteImport,
} as any)
const WWorkspaceIdIndexRoute = WWorkspaceIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdAuditRoute = WWorkspaceIdAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdSecurityRoute = WWorkspaceIdSecurityRouteImport.update({
  id: "/security",
  path: "/security",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdSurveysIndexRoute =
  WWorkspaceIdSurveysIndexRouteImport.update({
    id: "/surveys/",
    path: "/surveys/",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSurveysSurveyIdRoute =
  WWorkspaceIdSurveysSurveyIdRouteImport.update({
    id: "/surveys/$surveyId",
    path: "/surveys/$surveyId",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSurveysNewRoute = WWorkspaceIdSurveysNewRouteImport.update({
  id: "/surveys/new",
  path: "/surveys/new",
  getParentRoute: () => WWorkspaceIdRoute,
} as any)
const WWorkspaceIdTemplatesIndexRoute =
  WWorkspaceIdTemplatesIndexRouteImport.update({
    id: "/templates/",
    path: "/templates/",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdTemplatesTemplateIdRoute =
  WWorkspaceIdTemplatesTemplateIdRouteImport.update({
    id: "/templates/$templateId",
    path: "/templates/$templateId",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdTemplatesNewRoute =
  WWorkspaceIdTemplatesNewRouteImport.update({
    id: "/templates/new",
    path: "/templates/new",
    getParentRoute: () => WWorkspaceIdRoute,
  } as any)
const WWorkspaceIdSurveysSurveyIdIndexRoute =
  WWorkspaceIdSurveysSurveyIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => WWorkspaceIdSurveysSurveyIdRoute,
  } as any)
const WWorkspaceIdSurveysSurveyIdResponsesRoute =
  WWorkspaceIdSurveysSurveyIdResponsesRouteImport.update({
    id: "/responses",
    path: "/responses",
    getParentRoute: () => WWorkspaceIdSurveysSurveyIdRoute,
  } as any)
const WWorkspaceIdSurveysSurveyIdResultsRoute =
  WWorkspaceIdSurveysSurveyIdResultsRouteImport.update({
    id: "/results",
    path: "/results",
    getParentRoute: () => WWorkspaceIdSurveysSurveyIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/w/$workspaceId": typeof WWorkspaceIdRouteWithChildren
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId/security": typeof WWorkspaceIdSecurityRoute
  "/w/$workspaceId/": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/surveys/$surveyId": typeof WWorkspaceIdSurveysSurveyIdRouteWithChildren
  "/w/$workspaceId/surveys/new": typeof WWorkspaceIdSurveysNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/surveys/": typeof WWorkspaceIdSurveysIndexRoute
  "/w/$workspaceId/templates/": typeof WWorkspaceIdTemplatesIndexRoute
  "/w/$workspaceId/surveys/$surveyId/responses": typeof WWorkspaceIdSurveysSurveyIdResponsesRoute
  "/w/$workspaceId/surveys/$surveyId/results": typeof WWorkspaceIdSurveysSurveyIdResultsRoute
  "/w/$workspaceId/surveys/$surveyId/": typeof WWorkspaceIdSurveysSurveyIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId/security": typeof WWorkspaceIdSecurityRoute
  "/w/$workspaceId": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/surveys/new": typeof WWorkspaceIdSurveysNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/surveys": typeof WWorkspaceIdSurveysIndexRoute
  "/w/$workspaceId/templates": typeof WWorkspaceIdTemplatesIndexRoute
  "/w/$workspaceId/surveys/$surveyId/responses": typeof WWorkspaceIdSurveysSurveyIdResponsesRoute
  "/w/$workspaceId/surveys/$surveyId/results": typeof WWorkspaceIdSurveysSurveyIdResultsRoute
  "/w/$workspaceId/surveys/$surveyId": typeof WWorkspaceIdSurveysSurveyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/w/$workspaceId": typeof WWorkspaceIdRouteWithChildren
  "/w/$workspaceId/audit": typeof WWorkspaceIdAuditRoute
  "/w/$workspaceId/security": typeof WWorkspaceIdSecurityRoute
  "/w/$workspaceId/": typeof WWorkspaceIdIndexRoute
  "/w/$workspaceId/surveys/$surveyId": typeof WWorkspaceIdSurveysSurveyIdRouteWithChildren
  "/w/$workspaceId/surveys/new": typeof WWorkspaceIdSurveysNewRoute
  "/w/$workspaceId/templates/$templateId": typeof WWorkspaceIdTemplatesTemplateIdRoute
  "/w/$workspaceId/templates/new": typeof WWorkspaceIdTemplatesNewRoute
  "/w/$workspaceId/surveys/": typeof WWorkspaceIdSurveysIndexRoute
  "/w/$workspaceId/templates/": typeof WWorkspaceIdTemplatesIndexRoute
  "/w/$workspaceId/surveys/$surveyId/responses": typeof WWorkspaceIdSurveysSurveyIdResponsesRoute
  "/w/$workspaceId/surveys/$surveyId/results": typeof WWorkspaceIdSurveysSurveyIdResultsRoute
  "/w/$workspaceId/surveys/$surveyId/": typeof WWorkspaceIdSurveysSurveyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/w/$workspaceId"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId/security"
    | "/w/$workspaceId/"
    | "/w/$workspaceId/surveys/$surveyId"
    | "/w/$workspaceId/surveys/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/surveys/"
    | "/w/$workspaceId/templates/"
    | "/w/$workspaceId/surveys/$surveyId/responses"
    | "/w/$workspaceId/surveys/$surveyId/results"
    | "/w/$workspaceId/surveys/$surveyId/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId/security"
    | "/w/$workspaceId"
    | "/w/$workspaceId/surveys/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/surveys"
    | "/w/$workspaceId/templates"
    | "/w/$workspaceId/surveys/$surveyId/responses"
    | "/w/$workspaceId/surveys/$surveyId/results"
    | "/w/$workspaceId/surveys/$surveyId"
  id:
    | "__root__"
    | "/"
    | "/w/$workspaceId"
    | "/w/$workspaceId/audit"
    | "/w/$workspaceId/security"
    | "/w/$workspaceId/"
    | "/w/$workspaceId/surveys/$surveyId"
    | "/w/$workspaceId/surveys/new"
    | "/w/$workspaceId/templates/$templateId"
    | "/w/$workspaceId/templates/new"
    | "/w/$workspaceId/surveys/"
    | "/w/$workspaceId/templates/"
    | "/w/$workspaceId/surveys/$surveyId/responses"
    | "/w/$workspaceId/surveys/$surveyId/results"
    | "/w/$workspaceId/surveys/$surveyId/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WWorkspaceIdRoute: typeof WWorkspaceIdRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspaceId": {
      id: "/w/$workspaceId"
      path: "/w/$workspaceId"
      fullPath: "/w/$workspaceId"
      preLoaderRoute: typeof WWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/w/$workspaceId/": {
      id: "/w/$workspaceId/"
      path: "/"
      fullPath: "/w/$workspaceId/"
      preLoaderRoute: typeof WWorkspaceIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/audit": {
      id: "/w/$workspaceId/audit"
      path: "/audit"
      fullPath: "/w/$workspaceId/audit"
      preLoaderRoute: typeof WWorkspaceIdAuditRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/security": {
      id: "/w/$workspaceId/security"
      path: "/security"
      fullPath: "/w/$workspaceId/security"
      preLoaderRoute: typeof WWorkspaceIdSecurityRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/surveys/": {
      id: "/w/$workspaceId/surveys/"
      path: "/surveys"
      fullPath: "/w/$workspaceId/surveys/"
      preLoaderRoute: typeof WWorkspaceIdSurveysIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/surveys/$surveyId": {
      id: "/w/$workspaceId/surveys/$surveyId"
      path: "/surveys/$surveyId"
      fullPath: "/w/$workspaceId/surveys/$surveyId"
      preLoaderRoute: typeof WWorkspaceIdSurveysSurveyIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/surveys/new": {
      id: "/w/$workspaceId/surveys/new"
      path: "/surveys/new"
      fullPath: "/w/$workspaceId/surveys/new"
      preLoaderRoute: typeof WWorkspaceIdSurveysNewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/": {
      id: "/w/$workspaceId/templates/"
      path: "/templates"
      fullPath: "/w/$workspaceId/templates/"
      preLoaderRoute: typeof WWorkspaceIdTemplatesIndexRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/$templateId": {
      id: "/w/$workspaceId/templates/$templateId"
      path: "/templates/$templateId"
      fullPath: "/w/$workspaceId/templates/$templateId"
      preLoaderRoute: typeof WWorkspaceIdTemplatesTemplateIdRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/templates/new": {
      id: "/w/$workspaceId/templates/new"
      path: "/templates/new"
      fullPath: "/w/$workspaceId/templates/new"
      preLoaderRoute: typeof WWorkspaceIdTemplatesNewRouteImport
      parentRoute: typeof WWorkspaceIdRoute
    }
    "/w/$workspaceId/surveys/$surveyId/": {
      id: "/w/$workspaceId/surveys/$surveyId/"
      path: "/"
      fullPath: "/w/$workspaceId/surveys/$surveyId/"
      preLoaderRoute: typeof WWorkspaceIdSurveysSurveyIdIndexRouteImport
      parentRoute: typeof WWorkspaceIdSurveysSurveyIdRoute
    }
    "/w/$workspaceId/surveys/$surveyId/responses": {
      id: "/w/$workspaceId/surveys/$surveyId/responses"
      path: "/responses"
      fullPath: "/w/$workspaceId/surveys/$surveyId/responses"
      preLoaderRoute: typeof WWorkspaceIdSurveysSurveyIdResponsesRouteImport
      parentRoute: typeof WWorkspaceIdSurveysSurveyIdRoute
    }
    "/w/$workspaceId/surveys/$surveyId/results": {
      id: "/w/$workspaceId/surveys/$surveyId/results"
      path: "/results"
      fullPath: "/w/$workspaceId/surveys/$surveyId/results"
      preLoaderRoute: typeof WWorkspaceIdSurveysSurveyIdResultsRouteImport
      parentRoute: typeof WWorkspaceIdSurveysSurveyIdRoute
    }
  }
}

interface WWorkspaceIdSurveysSurveyIdRouteChildren {
  WWorkspaceIdSurveysSurveyIdResponsesRoute: typeof WWorkspaceIdSurveysSurveyIdResponsesRoute
  WWorkspaceIdSurveysSurveyIdResultsRoute: typeof WWorkspaceIdSurveysSurveyIdResultsRoute
  WWorkspaceIdSurveysSurveyIdIndexRoute: typeof WWorkspaceIdSurveysSurveyIdIndexRoute
}

const WWorkspaceIdSurveysSurveyIdRouteChildren: WWorkspaceIdSurveysSurveyIdRouteChildren =
  {
    WWorkspaceIdSurveysSurveyIdResponsesRoute:
      WWorkspaceIdSurveysSurveyIdResponsesRoute,
    WWorkspaceIdSurveysSurveyIdResultsRoute:
      WWorkspaceIdSurveysSurveyIdResultsRoute,
    WWorkspaceIdSurveysSurveyIdIndexRoute:
      WWorkspaceIdSurveysSurveyIdIndexRoute,
  }

const WWorkspaceIdSurveysSurveyIdRouteWithChildren =
  WWorkspaceIdSurveysSurveyIdRoute._addFileChildren(
    WWorkspaceIdSurveysSurveyIdRouteChildren,
  )

interface WWorkspaceIdRouteChildren {
  WWorkspaceIdAuditRoute: typeof WWorkspaceIdAuditRoute
  WWorkspaceIdSecurityRoute: typeof WWorkspaceIdSecurityRoute
  WWorkspaceIdIndexRoute: typeof WWorkspaceIdIndexRoute
  WWorkspaceIdSurveysSurveyIdRoute: typeof WWorkspaceIdSurveysSurveyIdRouteWithChildren
  WWorkspaceIdSurveysNewRoute: typeof WWorkspaceIdSurveysNewRoute
  WWorkspaceIdTemplatesTemplateIdRoute: typeof WWorkspaceIdTemplatesTemplateIdRoute
  WWorkspaceIdTemplatesNewRoute: typeof WWorkspaceIdTemplatesNewRoute
  WWorkspaceIdSurveysIndexRoute: typeof WWorkspaceIdSurveysIndexRoute
  WWorkspaceIdTemplatesIndexRoute: typeof WWorkspaceIdTemplatesIndexRoute
}

const WWorkspaceIdRouteChildren: WWorkspaceIdRouteChildren = {
  WWorkspaceIdAuditRoute: WWorkspaceIdAuditRoute,
  WWorkspaceIdSecurityRoute: WWorkspaceIdSecurityRoute,
  WWorkspaceIdIndexRoute: WWorkspaceIdIndexRoute,
  WWorkspaceIdSurveysSurveyIdRoute:
    WWorkspaceIdSurveysSurveyIdRouteWithChildren,
  WWorkspaceIdSurveysNewRoute: WWorkspaceIdSurveysNewRoute,
  WWorkspaceIdTemplatesTemplateIdRoute: WWorkspaceIdTemplatesTemplateIdRoute,
  WWorkspaceIdTemplatesNewRoute: WWorkspaceIdTemplatesNewRoute,
  WWorkspaceIdSurveysIndexRoute: WWorkspaceIdSurveysIndexRoute,
  WWorkspaceIdTemplatesIndexRoute: WWorkspaceIdTemplatesIndexRoute,
}

const WWorkspaceIdRouteWithChildren = WWorkspaceIdRoute._addFileChildren(
  WWorkspaceIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WWorkspaceIdRoute: WWorkspaceIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
